<template lang="pug">
    div
        f-dialog-confirm(v-model="dialog" :message="message" :events="events"
            v-on:reinquiry="doReinquiry" v-on:reverse="doReverse" 
            v-on:billingTransaction="doTransaction"
            v-on:dialog="dialog = $event" )
        v-data-table(
            hide-default-footer 
            :headers="headers" 
            :items="listData" 
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            :page.sync="page"
        )
            template(v-slot:top="{item}")
                 div(class="caption font-weight-bold primary white--text text-center justify-center") DATA POTONGAN
            template(v-slot:item.kodeMap="{item}")
                v-chip(small :color="dataValid(item) ? 'info' : 'error'" dark) {{ item.kodeMap }} - {{ item.namaMap }}
            template(v-slot:item.status="{item}")
                v-chip(small v-if="item.billing && item.billing.status" :color="item.billing.status == 'SUCCESS' ? 'info' : item.billing.status == 'FAILED' ? 'error' : 'warning'" dark) {{ item.billing.status }}
            template(v-slot:item.nilai="{item}")
                div {{ item.nilai | decimalformat }}
            template(v-slot:item.action="{item}")
                v-layout(wrap justify-center menu-btn-sm my-1)
                    f-button-option(v-if="item.billing || (edit && !dataValid(item) || item.detail && item.productId && item.productId != 'MPN_G2') " 
                        :reinquiry="reinquiry && item.billing && !item.billing.ntpn && item.billing.requestId && item.billing.status && (item.billing.status == 'SUSPECT')" 
                        :reverse="reverse && item.billing && item.billing.requestId && item.billing.status && (item.billing.status == 'FAILED_EC')"
                        :view="item.billing && item.billing.billnum" :createBill="edit && !dataValid(item)"
                        :process="billingTransaction && item.billing && item.billing.billnum && item.billing.status && (item.billing.status == 'ACTIVE' || item.billing.status == 'FAILED')"
                        :update="billingUpdate && item.billing && item.billing.billnum && item.billing.status && (item.billing.status == 'CHANGE_BILLING')"
                        :viewPhri="item.detail && item.productId && item.productId != 'MPN_G2'"
                        v-on:reinquiry="confirmReinquiry(item)" v-on:reverse="confirmReverse(item)" v-on:view="detail(item)"
                        v-on:createBill="update(item)" v-on:process="confirmTransaction(item)" v-on:update="updateBillingNumber(item)" v-on:viewPhri="detailPhri(item)")
                
        div(class="text-xs-center")
            v-pagination(v-model="page" :length="pageCount")
</template>
<script>
export default {
    name: "FPemdaPotonganTable",
    props: ["data", "edit", "reinquiry", "reverse", "billingTransaction", "billingUpdate"],
    data() {
        return {
            headers: [
                {text: 'Kode Map', value: 'kodeMap', sortable: false, width: "50%", class: "primary--text"},
                {text: '', value: 'status', sortable: false, width: "10%", class: "primary--text"},
                {text: 'Nominal', align: "right", value: 'nilai', sortable: false, width: "25%", class: "primary--text"},
                {text: '', value: 'action', sortable: false, width: "110px"},
            ],
            listData: [],
            itemsPerPage: 5,
            criteria: "",
            pageCount: 0,
            page: 1,
            dialog: false,
            message: "Apakah anda yakin akan melakukan reinquiry transaksi ?",
            events: "reinquiry",
            billing: null,
            item: null
        }
    },
    mounted() {
        this.listData = this.data ? this.data : []
    },
    watch: {
        data(val) {
            this.listData = val ? val : []
        }
    },
    methods: {
        doReset(){
            this.itemsPerPage = 5;
            this.criteria = "";
            this.pageCount = 0;
            this.page = 1;
            this.message = "Apakah anda yakin akan melakukan reinquiry transaksi ?";
            this.events = "reinquiry";
        },
        dataValid(item){
            if (item.needCreateBilling === true) {
                if (item.billing && item.billing.billnum) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },
        update(item){
            this.$emit("data", item);
        },
        detail(item){
            this.$emit("detail", item);
        },
        detailPhri(item){
          this.$emit("detailPhri", item);
        },
        confirmReinquiry(item) {
            // if (item.billing.opendate != this.$options.filters.localdate(new Date())) {
            //     this.$message.error("Reinquiry hanya bisa dilakukan di hari yang sama");
            // } else {
                this.dialog = true;
                this.message = "Apakah anda yakin akan melakukan reinquiry transaksi ?";
                this.events = "reinquiry";
                this.billing = item.billing;
            // }
        },
        doReinquiry() {
            this.$progress.show(true);
            this.$http.post("api/kasda/reinquiry", 
                {
                    requestId: this.billing.requestId
                })
            .then(success => {
                this.$message.success("Data berhasil di reinquiry");
                this.$emit("reset");
            }, err => {
                this.$message.error(err.response.data.message);
            }).finally(() => this.$progress.show(false));
        },
        confirmReverse(item){
            if (item.billing.opendate != this.$options.filters.localdate(new Date())) {
                this.$message.error("Reversal hanya bisa dilakukan di hari yang sama");
            } else {
                this.dialog = true;
                this.message = "Apakah anda yakin akan melakukan reversal transaksi ?";
                this.events = "reverse";
                this.item = item;
                this.billing = item.billing;
            }
        },
        doReverse() {
            this.$progress.show(true);
            this.$http.post("api/transaction/reverse", 
                {
                    requestId: this.billing.requestId,
                    reason: 'Reverse journal [' + this.billing.requestId + '] - [' + this.billing.billnum + ']'
                })
            .then(success => {
                this.$message.success("Data berhasil di reversal");
                this.$emit("reset");
            }, err => {
                this.$message.error(err.response.data.message);
            }).finally(() => this.$progress.show(false));
        },
        doTransaction() {
            this.$emit("transaction", this.item);
        },
        confirmTransaction(item){
            this.dialog = true;
            this.message = "Apakah anda yakin akan melakukan transaksi potongan?";
            this.events = "billingTransaction";
            this.item = item;
        },
        updateBillingNumber(item){
            this.$emit("updateBilling", item);
        },
    },
}
</script>